import { render, staticRenderFns } from "./purchasePie.vue?vue&type=template&id=365255e1&scoped=true&"
import script from "./purchasePie.vue?vue&type=script&lang=js&"
export * from "./purchasePie.vue?vue&type=script&lang=js&"
import style0 from "./purchasePie.vue?vue&type=style&index=0&id=365255e1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365255e1",
  null
  
)

export default component.exports